module.exports = __webpack_public_path__ + "img/GTP-box.989d4aae.svg";